export enum SummaryIGInternalFilters {
  BOTH_IG,
  GREATER_3_IG,
  LESS_3_IG,
  BOTH_IG_FALSE,
}
